
export enum InterviewStatus {
  Scheduled,
  InProgress,
  Completed,
  Failed,
  AwaitingSelection,
  Incomplete,
}